<template>
  <v-card>
    <v-container fluid class="py-0">
      <v-row dense justify="space-between">
        <v-col @click="collapse = !collapse">
          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> CID </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ diagnosticHypothesis.cid.codeDescription }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Sub CID </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ cidItemDescription }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Local </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ diagnosticHypothesisSiteName }}
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <v-menu offset-y auto :disabled="disabled">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    small
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    :disabled="disabled"
                  >
                    {{ diagnosticHypothesis.statusHypothesis }}
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="confirmDiagnosticHypothesis">
                    <v-list-item-title> Confirmar </v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="discardDiagnosticHypothesis">
                    <v-list-item-title> Descartar </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      attendance.id === diagnosticHypothesis.originAttendance.id
                    "
                    @click="deleteDiagnosticHypothesis"
                  >
                    <v-list-item-title> Excluir </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>

            <v-col
              cols="auto"
              v-if="diagnosticHypothesis.statusHypothesis !== 'descartada'"
            >
              <v-menu offset-y auto :disabled="disabled">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="statusColor"
                    :dark="!disabled"
                    small
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    :disabled="disabled"
                  >
                    {{ diagnosticHypothesis.diagnosticHypothesisStatus.name }}
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-for="status in diagnosticHypothesisStatuses"
                    :key="status.id"
                    @click="updateDiagnosticHypothesisStatus(status.id)"
                  >
                    <v-list-item-title>
                      {{ status.name }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row dense v-if="collapse">
        <v-col>
          <v-row align="center" dense v-if="!edit">
            <v-col cols="auto" class="font-weight-bold"> Descrição </v-col>
          </v-row>

          <v-row align="center" dense>
            <v-col v-if="!edit" @click="collapse = !collapse">
              {{ diagnosticHypothesis.description }}
            </v-col>

            <v-col v-else>
              <v-textarea
                v-model.trim="diagnosticHypothesis.description"
                outlined
                dense
                hide-details
                rows="2"
                label="Descrição"
                :disabled="disabled"
              />
            </v-col>

            <v-col cols="auto" class="pt-0">
              <v-btn
                small
                v-if="edit"
                @click="edit = false"
                :disabled="disabled"
              >
                Salvar
              </v-btn>

              <v-btn small v-else @click="edit = true" :disabled="disabled">
                Editar
              </v-btn>
            </v-col>
          </v-row>

          <v-row dense class="text-body-2">
            <v-col cols="auto">
              Criado em
              {{
                $moment(
                  diagnosticHypothesis.createdAt,
                  "YYYY-MM-DD HH:mm:ss ZZ"
                ) | moment("DD/MM/YYYY HH:mm")
              }}
            </v-col>

            <v-col cols="auto">
              Ultima atualização em
              {{
                $moment(
                  diagnosticHypothesis.updatedAt,
                  "YYYY-MM-DD HH:mm:ss ZZ"
                ) | moment("DD/MM/YYYY HH:mm")
              }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import GET_DIAGNOSTIC_HYPOTHESIS_STATUSES from "@/graphql/diagnostic_hypothesis_statuses.gql";
import DELETE_DIAGNOSTIC_HYPOTHESIS from "@/graphql/delete_diagnostic_hypothesis.gql";
import CONFIRM_DIAGNOSTIC_HYPOTHESIS from "@/graphql/confirm_diagnostic_hypothesis.gql";
import DISCARD_DIAGNOSTIC_HYPOTHESIS from "@/graphql/discard_diagnostic_hypothesis.gql";
import UPDATE_DIAGNOSTIC_HYPOTHESIS_STATUS from "@/graphql/update_diagnostic_hypothesis_status.gql";
import UPDATE_DIAGNOSTIC_HYPOTHESIS_DESCRIPTION from "@/graphql/update_diagnostic_hypothesis_description.gql";

export default {
  name: "DiagnosticHypothesis",
  props: {
    diagnosticHypothesis: Object,
    attendance: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      diagnosticHypothesisStatuses: [],
      edit: false,
      collapse: false,
    };
  },
  created: function () {
    this.debouncedUpdateDiagnosticHypothesisDescription = this.lodash.debounce(
      this.updateDiagnosticHypothesisDescription,
      2000
    );
  },
  watch: {
    "diagnosticHypothesis.description": function () {
      this.debouncedUpdateDiagnosticHypothesisDescription();
    },
  },
  apollo: {
    diagnosticHypothesisStatuses: {
      query: GET_DIAGNOSTIC_HYPOTHESIS_STATUSES,
    },
  },
  computed: {
    cidItemDescription() {
      if (this.diagnosticHypothesis.cidItem) {
        return this.diagnosticHypothesis.cidItem.description;
      }

      return "";
    },
    diagnosticHypothesisSiteName() {
      if (this.diagnosticHypothesis.diagnosticHypothesisSite) {
        return this.diagnosticHypothesis.diagnosticHypothesisSite.name;
      }

      return "";
    },
    statusColor() {
      switch (
        this.diagnosticHypothesis.diagnosticHypothesisStatus.name
          .toLowerCase()
      ) {
        case "curado":
          return "primary";
        case "estável":
          return "secondary1";
        case "melhora":
          return "success";
        case "piora":
          return "warning-orange";
        case "inalterado":
          return "secondary";
        default:
          return "secondary";
      }
    },
  },
  methods: {
    deleteDiagnosticHypothesis() {
      if (this.disabled) return;

      this.apolloMutate({
        mutation: DELETE_DIAGNOSTIC_HYPOTHESIS,
        variables: {
          diagnosticHypothesisId: this.diagnosticHypothesis.id,
        },
      });
    },
    confirmDiagnosticHypothesis() {
      if (this.disabled) return;

      this.apolloMutate({
        mutation: CONFIRM_DIAGNOSTIC_HYPOTHESIS,
        variables: {
          diagnosticHypothesisId: this.diagnosticHypothesis.id,
        },
      });
    },
    discardDiagnosticHypothesis() {
      if (this.disabled) return;

      this.apolloMutate({
        mutation: DISCARD_DIAGNOSTIC_HYPOTHESIS,
        variables: {
          diagnosticHypothesisId: this.diagnosticHypothesis.id,
        },
      });
    },
    updateDiagnosticHypothesisStatus(diagnosticHypothesisStatusId) {
      if (this.disabled) return;

      this.apolloMutate({
        mutation: UPDATE_DIAGNOSTIC_HYPOTHESIS_STATUS,
        variables: {
          diagnosticHypothesisId: this.diagnosticHypothesis.id,
          diagnosticHypothesisStatusId: diagnosticHypothesisStatusId,
        },
      });
    },
    updateDiagnosticHypothesisDescription() {
      if (this.disabled) return;

      this.apolloMutate({
        mutation: UPDATE_DIAGNOSTIC_HYPOTHESIS_DESCRIPTION,
        variables: {
          diagnosticHypothesisId: this.diagnosticHypothesis.id,
          description: this.diagnosticHypothesis.description,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
